import React from "react"

import { StyledFooter } from "./Footer.styled"
import Button from "../Button/Button.styled"
import { Link } from "gatsby"

const Footer = () => {
  return (
    <StyledFooter>
      <div>
        <div style={{marginBottom:"24px"}}>
          <Link to="https://panel.amlex.pl/SygnFirmy/SecurePage/38b6bbb1a4fb42c7a2a9b2d7035b9ab4" style={{textDecoration:"none"}}>
            <Button red>Kanał zgłoszeń wewnętrznych</Button>
          </Link>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path d="M20 22.621l-3.521-6.795c-.008.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.083-1.026-3.493-6.817-2.106 1.039c-7.202 3.755 4.233 25.982 11.6 22.615.121-.055 2.102-1.029 2.11-1.033z" />
          </svg>
          <h4>+48 538 436 332</h4>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.848 12.459c.202.038.202.333.001.372-1.907.361-6.045 1.111-6.547 1.111-.719 0-1.301-.582-1.301-1.301 0-.512.77-5.447 1.125-7.445.034-.192.312-.181.343.014l.985 6.238 5.394 1.011z" />
          </svg>
          <h4>Poniedziałek - Sobota: 10:00 do 22:00</h4>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
          </svg>
          <h4>
            ulica Aleksandra Kamińskiego 10/32 <br />
            03-130 Warszawa, Polska
          </h4>
        </div>
        <div style={{ marginLeft: "24px" }}>
          <h4>Numer KRS 0001001980</h4>
        </div>
        <div style={{ marginLeft: "24px" }}>
          <h4>NIP 5242955219</h4>
        </div>
        <div style={{ marginLeft: "24px" }}>
          <h4>REGON 523651712</h4>
        </div>
      </div>
    </StyledFooter>
  )
}

export default Footer
